import { useEffect, useState } from "react";
import api, { fmtDate, formatApiError } from "@/lib/apiClient";
import AdminLayout from "@/layouts/AdminLayout";
import { amdenNav } from "@/lib/navConfig";
import { PageHeader } from "@/components/Common";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { toast } from "sonner";

export default function EmploymentRules() {
  const [prsi, setPrsi] = useState([]);
  const [rules, setRules] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ prsi_class: "A1", employer_rate: 11.05, threshold: 441, effective_start: "" });

  const load = () => { api.get("/prsi-classes").then((r) => setPrsi(r.data)); api.get("/employment-rules").then((r) => setRules(r.data)); };
  useEffect(() => { load(); }, []);
  const submit = async () => {
    try { await api.post("/prsi-classes", { ...form, employer_rate: Number(form.employer_rate), threshold: Number(form.threshold) }); toast.success("PRSI rule added (effective-dated)"); setOpen(false); load(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };
  return (
    <AdminLayout nav={amdenNav} title="Employment Rules">
      <PageHeader title="Employment & Calculation Rules" subtitle="Effective-dated PRSI and cost rules">
        <Button data-testid="new-prsi-btn" onClick={() => setOpen(true)} className="bg-slate-900 text-white">+ New PRSI rule</Button>
      </PageHeader>
      <h3 className="text-xs font-bold uppercase tracking-wider text-zinc-500 mb-2">Employer PRSI Classes</h3>
      <div className="bg-white border border-zinc-200 rounded-md overflow-x-auto kqm-scroll mb-6">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs font-semibold uppercase tracking-wider text-zinc-500 border-b border-zinc-200">
            <th className="p-3">Class</th><th className="p-3 text-right">Employer Rate %</th><th className="p-3 text-right">Threshold</th><th className="p-3">Effective from</th><th className="p-3">Effective to</th>
          </tr></thead>
          <tbody>
            {prsi.map((p) => (
              <tr key={p.id} className="border-b border-zinc-50 hover:bg-zinc-50">
                <td className="p-3 num font-medium">{p.prsi_class}</td>
                <td className="p-3 num text-right">{p.employer_rate}%</td>
                <td className="p-3 num text-right">{p.threshold}</td>
                <td className="p-3 num">{fmtDate(p.effective_start)}</td>
                <td className="p-3 num">{p.effective_end ? fmtDate(p.effective_end) : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <h3 className="text-xs font-bold uppercase tracking-wider text-zinc-500 mb-2">Other Cost Rules</h3>
      <div className="bg-white border border-zinc-200 rounded-md overflow-x-auto kqm-scroll">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-xs font-semibold uppercase tracking-wider text-zinc-500 border-b border-zinc-200">
            <th className="p-3">Name</th><th className="p-3">Type</th><th className="p-3 text-right">Value</th><th className="p-3">Effective from</th>
          </tr></thead>
          <tbody>
            {rules.map((r) => (
              <tr key={r.id} className="border-b border-zinc-50"><td className="p-3">{r.name}</td><td className="p-3 text-zinc-500">{r.type}</td><td className="p-3 num text-right">{r.value}</td><td className="p-3 num">{fmtDate(r.effective_start)}</td></tr>
            ))}
          </tbody>
        </table>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm">
          <DialogHeader><DialogTitle>New PRSI rule</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>PRSI class</Label><Input data-testid="p-class" value={form.prsi_class} onChange={(e) => setForm({ ...form, prsi_class: e.target.value })} className="mt-1" /></div>
            <div><Label>Employer rate %</Label><Input data-testid="p-rate" type="number" value={form.employer_rate} onChange={(e) => setForm({ ...form, employer_rate: e.target.value })} className="mt-1" /></div>
            <div><Label>Threshold</Label><Input data-testid="p-threshold" type="number" value={form.threshold} onChange={(e) => setForm({ ...form, threshold: e.target.value })} className="mt-1" /></div>
            <div><Label>Effective from</Label><Input data-testid="p-start" type="date" value={form.effective_start} onChange={(e) => setForm({ ...form, effective_start: e.target.value })} className="mt-1" /></div>
            <Button data-testid="p-submit" onClick={submit} className="w-full bg-slate-900 text-white">Add rule</Button>
          </div>
        </DialogContent>
      </Dialog>
    </AdminLayout>
  );
}
